module.exports = __webpack_public_path__ + "img/interrogator.acaae16d.png";